const initState = {
  isUpdating: false,
  error: null,
}

export default initState
